// src/utils/programs/pricingUnitHelper.js

/**
 * Map pricing unit ID to code
 * This is based on the system's pricing unit structure
 */
export const getPricingUnitCode = (pricingUnitId) => {
    const mapping = {
        1: 'per_person',
        2: 'per_night',
        3: 'per_unit',
    };

    return mapping[pricingUnitId] || null;
};

/**
 * Map pricing type text (English) to code
 * Fallback method when pricingUnitId is not available
 */
export const getPricingCodeFromText = (priceTypeText) => {
    if (!priceTypeText) return null;

    const text = typeof priceTypeText === 'object' ? priceTypeText.en : priceTypeText;
    const normalized = text?.toLowerCase().trim();

    if (normalized?.includes('person')) return 'per_person';
    if (normalized?.includes('night')) return 'per_night';
    if (normalized?.includes('unit')) return 'per_unit';

    return null;
};

/**
 * Get pricing unit code from product data
 * Tries pricingUnitId first, then falls back to priceType text
 */
export const extractPricingUnitCode = (productData) => {
    // Try pricing_unit_id first
    if (productData.pricing_unit_id || productData.pricingunitid) {
        const id = productData.pricing_unit_id || productData.pricingunitid;
        const code = getPricingUnitCode(id);
        if (code) return code;
    }

    // Fallback to price_type text
    if (productData.price_type || productData.pricetype) {
        const text = productData.price_type || productData.pricetype;
        return getPricingCodeFromText(text);
    }

    return null;
};
